import { render, staticRenderFns } from "./cModalAddCall.vue?vue&type=template&id=4195cee2"
import script from "./cModalAddCall.vue?vue&type=script&lang=js"
export * from "./cModalAddCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports